import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslationKeyTranslation } from 'server/shared/models/translation';

@Component({
  selector: 'app-toggle-buttons',
  templateUrl: 'toggle-buttons.component.html',
  styleUrls: ['toggle-buttons.component.scss'],
})
export class ToggleButtonsComponent {
  i18n?: TranslationKeyTranslation;

  @Input() value: any;
  @Input() trueLabel?: string;
  @Input() falseLabel?: string;
  @Input() disabled?: boolean;
  @Output() valueChange = new EventEmitter<boolean>();

  constructor() {}

  toggle(value?: boolean): void {
    if (value !== undefined) {
      if (value === this.value) {
        this.value = undefined;
      } else {
        this.value = value;
      }
    } else {
      this.value = !this.value;
    }
    this.valueChange.emit(this.value);
  }
}
